import { Calendar, Pencil, Trash2, Clock3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  notificationTypeLabel,
  typeIcon,
  formatCreatedAt,
  relativeCreatedAt,
  audienceLabel,
  deliverySummary,
} from "./notificationHelpers";
import { DetailCoverShowcase } from "../../components/DetailCoverHero";
import {
  NotificationTypeBadge,
  NotificationTypeIcon,
  NotificationAudienceBadge,
  NotificationDeliveryBadge,
} from "./NotificationParts";
import "../teachers/teacherDetails.css";
import "../activities/activities.css";
import "./notifications.css";

export default function NotificationProfile({ notification, onDelete }) {
  const navigate = useNavigate();
  const TypeIcon = typeIcon(notification?.type);

  return (
    <div className="td-page">
      <div className="td-main">
        <article className="td-card">
          <DetailCoverShowcase
            coverKey={notification?._id}
            backLabel="Back to notices"
            onBack={() => navigate("/notifications")}
          >
            <div className="notif-detail-icon-wrap">
              <NotificationTypeIcon type={notification?.type} size={36} className="is-detail" />
              <p className="notif-detail-type-label">{notificationTypeLabel(notification.type)}</p>
            </div>
          </DetailCoverShowcase>

          <div className="act-detail-body">
            <div className="act-detail-head">
              <div className="act-detail-head-copy">
                <span className="act-detail-kicker">
                  <TypeIcon size={14} />
                  Admin notice
                </span>
                <div className="act-detail-title-row">
                  <h2>{notification.title || "Notification"}</h2>
                  <NotificationTypeBadge type={notification.type} />
                  <NotificationAudienceBadge
                    sendTo={notification.sendTo || "ALL"}
                    notification={notification}
                  />
                  <NotificationDeliveryBadge notification={notification} />
                </div>
              </div>
            </div>

            <div className="act-detail-meta">
              <span>
                <i className="is-orange">
                  <Calendar size={14} />
                </i>
                {formatCreatedAt(notification.createdAt)}
              </span>
              {notification.createdAt ? (
                <span>
                  <i className="is-orange">
                    <Clock3 size={14} />
                  </i>
                  {relativeCreatedAt(notification.createdAt)}
                </span>
              ) : null}
            </div>

            <section className="act-detail-section">
              <h3>Delivery</h3>
              <div className="fee-detail-meta-grid">
                <div className="fee-detail-meta-item">
                  <span>Audience</span>
                  <strong>{audienceLabel(notification.sendTo || "ALL", notification)}</strong>
                </div>
                {notification.deliveryStatus ? (
                  <>
                    <div className="fee-detail-meta-item">
                      <span>Delivery status</span>
                      <strong>{notification.deliveryStatus}</strong>
                    </div>
                    <div className="fee-detail-meta-item">
                      <span>Recipients</span>
                      <strong>{deliverySummary(notification) || "—"}</strong>
                    </div>
                  </>
                ) : null}
              </div>
            </section>

            <section className="act-detail-section">
              <h3>Message</h3>
              <p className="notif-content-block">
                {notification.content || "No content provided."}
              </p>
            </section>
          </div>
        </article>

        <div className="td-actions act-detail-actions">
          <button
            type="button"
            className="td-action is-primary"
            onClick={() => navigate(`/notifications/edit/${notification._id}`)}
          >
            <Pencil size={15} />
            Edit notice
          </button>
          <button type="button" className="td-action is-danger" onClick={onDelete}>
            <Trash2 size={15} />
            Recall notice
          </button>
        </div>
      </div>
    </div>
  );
}
